// Staged-loading skeleton for the canvas (TASK-601). Rendered while a summon's
// LLM round-trip is in flight, so the gap between dock submit and widget mount
// never reads as a hang. 150ms mount delay so fast responses don't flash it.
import { useEffect, useState } from 'react';

export function WidgetSkeleton({ status }: { status: string }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(t);
  }, []);
  if (!visible) return null;
  return (
    <div
      data-testid="widget-skeleton"
      className="col-span-full flex flex-col gap-3 rounded-2xl border border-border bg-card p-4"
    >
      <div className="h-4 w-2/5 animate-pulse rounded bg-accent" />
      <div className="h-3 w-full animate-pulse rounded bg-accent" />
      <div className="h-3 w-3/4 animate-pulse rounded bg-accent" />
      <div className="h-3 w-1/2 animate-pulse rounded bg-accent" />
      <p className="mt-1 text-xs text-muted-foreground" aria-live="polite">
        {status}
      </p>
    </div>
  );
}
